(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('preorder-availability')) {
    class PreorderAvailability extends HTMLElement {
      connectedCallback() {
        const startDays = Number(this.dataset.startDays || 7);
        const endDays = Number(this.dataset.endDays || 10);
        const startDate = new Date();
        const endDate = new Date();
        startDate.setHours(12, 0, 0, 0);
        endDate.setHours(12, 0, 0, 0);
        startDate.setDate(startDate.getDate() + startDays);
        endDate.setDate(endDate.getDate() + endDays);

        const formatter = new Intl.DateTimeFormat(this.dataset.locale || document.documentElement.lang || 'en', {
          day: 'numeric',
          month: 'long',
        });
        const dates = this.querySelector('[data-preorder-dates]');

        if (dates) {
          dates.textContent =
            typeof formatter.formatRange === 'function'
              ? formatter.formatRange(startDate, endDate)
              : `${formatter.format(startDate)}–${formatter.format(endDate)}`;
        }
      }
    }

    customElements.define('preorder-availability', PreorderAvailability);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    if (window.location.pathname.replace(/\/$/, '').endsWith('/pages/contact')) {
    const brand = new URLSearchParams(window.location.search).get('brand')?.trim().slice(0, 100);
    if (brand) document.querySelectorAll('.contact-form__form').forEach(form => {
      const note = form.querySelector('[data-brand-request]');
      const field = form.querySelector('[data-brand-request-input]');
      const body = form.querySelector('textarea[name="contact[body]"]');
      if (note) { note.hidden = false; note.textContent = `Σας ενδιαφέρει το ${brand}; Ζητήστε τον τιμοκατάλογο για παραγγελία εκτός site.`; }
      if (field) { field.value = brand; field.disabled = false; }
      if (body && !body.value.trim()) body.value = `Παρακαλώ στείλτε μου τιμοκατάλογο για το brand ${brand}.`;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
